/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BusinessObjectDataNotificationRegistration } from './businessObjectDataNotificationRegistration';


export interface BusinessObjectDataNotificationRegistrationSearchResponse { 
    /**
     * Values that identify a business object data notification registration search response
     */
    businessObjectDataNotificationRegistrations?: Array<BusinessObjectDataNotificationRegistration>;
}
